// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.country-graph-paginated {
  display: flex;
  flex-direction: column;
}
.country-graph-paginated .paginated-country-graph {
  width: 100%;
  flex: 1 1;
}
.country-graph-paginated .paginated-country-graph-paginated {
  align-self: flex-end;
  font-size: 0.875rem; /* 14/16 */
  margin-right: 11px;
  display: flex;
  align-items: center;
}
.country-graph-paginated .paginated-country-graph-paginated .next,
.country-graph-paginated .paginated-country-graph-paginated .previous {
  height: 24px;
  width: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  padding: 0;
}
.country-graph-paginated .paginated-country-graph-paginated .next svg,
.country-graph-paginated .paginated-country-graph-paginated .previous svg {
  fill: var(--gray);
}
.country-graph-paginated .paginated-country-graph-paginated .next:hover:not(:disabled) svg,
.country-graph-paginated .paginated-country-graph-paginated .previous:hover:not(:disabled) svg {
  fill: var(--gray_dark1);
}
.country-graph-paginated .paginated-country-graph-paginated .next .arrow-icon,
.country-graph-paginated .paginated-country-graph-paginated .previous .arrow-icon {
  height: 20px;
  width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/CountryGraphPaginated/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,SAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA,EAAA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AAEI;;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AAAN;AAEM;;EACE,iBAAA;AACR;AAEM;;EACE,uBAAA;AACR;AAEM;;EACE,YAAA;EACA,WAAA;AACR","sourcesContent":[".country-graph-paginated {\n  display: flex;\n  flex-direction: column;\n\n  .paginated-country-graph {\n    width: 100%;\n    flex: 1;\n  }\n\n  .paginated-country-graph-paginated {\n    align-self: flex-end;\n    font-size: 0.875rem; /* 14/16 */\n    margin-right: 11px;\n    display: flex;\n    align-items: center;\n\n    .next,\n    .previous {\n      height: 24px;\n      width: 24px;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      margin-left: 8px;\n      padding: 0;\n\n      svg {\n        fill: var(--gray);\n      }\n\n      &:hover:not(:disabled) svg {\n        fill: var(--gray_dark1);\n      }\n\n      .arrow-icon {\n        height: 20px;\n        width: 20px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
